import React from 'react';
import { Chip } from '@mui/material';

const StatusBadge = ({ status, variant = 'filled', size = 'small' }) => {
  const getStatusColor = (status) => {
    const statusLower = status?.toLowerCase();
    
    switch (statusLower) {
      case 'active':
      case 'completed':
      case 'closed won':
      case 'positive':
        return { color: 'success', bgcolor: '#f0fdf4', textColor: '#166534' };
      case 'at risk':
      case 'expiring':  
      case 'medium':
      case 'trial':
        return { color: 'warning', bgcolor: '#fefce8', textColor: '#a16207' };
      case 'dormant':
      case 'expired':
      case 'closed lost':
      case 'high':
      case 'negative':
        return { color: 'error', bgcolor: '#fef2f2', textColor: '#dc2626' };
      case 'new':
      case 'prospect':
      case 'qualified':
      case 'low':
      case 'neutral':
        return { color: 'info', bgcolor: '#f0f9ff', textColor: '#0369a1' };
      case 'enterprise':
        return { color: 'default', bgcolor: '#1e293b', textColor: '#ffffff' };
      case 'premium':
        return { color: 'default', bgcolor: '#7c3aed', textColor: '#ffffff' };
      case 'standard':
        return { color: 'default', bgcolor: '#64748b', textColor: '#ffffff' };
      default:
        return { color: 'default', bgcolor: '#f1f5f9', textColor: '#475569' };
    }
  };

  const { color, bgcolor, textColor } = getStatusColor(status);

  if (variant === 'outlined') {
    return (
      <Chip
        label={status}
        variant="outlined"
        size={size}
        color={color}
        sx={{ 
          fontWeight: 600,
          fontSize: '0.75rem',
          borderColor: textColor,
          color: textColor
        }}
      />
    );
  }

  return (
    <Chip
      label={status}
      size={size}
      sx={{
        bgcolor,
        color: textColor,
        fontWeight: 600,
        fontSize: '0.75rem',
        '& .MuiChip-label': {
          px: 1.5
        }
      }}
    />
  );
};

export default StatusBadge;
